<div class="container-fluid delete_page">
  <ng-container *ngIf="deletionCompleted; else deleteConfirmation">
    <div class="deletion-state" role="status" aria-live="polite">
      <span class="deletion-success-icon" aria-hidden="true">✓</span>
      <h3 class="modal-title mt-3 mb-2 text-center">Account deleted</h3>
      <p class="text-center theme-color mb-4">
        Your account has been deleted. You can sign in with another account.
      </p>
      <button class="btn btn-black font-16 mw-auto" (click)="goToSignIn()">
        Go to Sign in
      </button>
    </div>
  </ng-container>

  <ng-template #deleteConfirmation>
    <div class="row mx-2 d-flex justify-content-center">
      <h3 class="modal-title mt-2 mb-2 text-center">Delete Account</h3>
    </div>
    <p class="text-center theme-color mb-2 delete_account">
      Are you sure you want to delete this account?
    </p>
    <p *ngIf="deletionError" class="text-center text-danger mb-2" role="alert">
      {{ deletionError }}
    </p>

    <div
      *ngIf="deleting"
      class="deletion-state"
      role="status"
      aria-live="polite"
    >
      <span
        class="citizex-spinner citizex-spinner--lg"
        aria-hidden="true"
      ></span>
      <p class="text-center theme-color mt-3 mb-0">
        Deleting your account&hellip; This may take a few moments.
      </p>
    </div>

    <div *ngIf="!deleting" class="col-12 d-flex justify-content-center">
      <button
        type="reset"
        class="btn btn-outline-black mt-4 mb-2 mx-2 font-16 mw-auto"
        [routerLink]="['/homepage']"
      >
        No
      </button>
      <button
        class="btn btn-black mt-4 mb-2 mx-2 font-16 mw-auto"
        (click)="deleteAccount()"
      >
        Yes
      </button>
    </div>
  </ng-template>
</div>
